import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Icon } from '../../../components';
import { closeModal } from '../../../redux/actions';
import colors from '../../../utils/colors';

const DeleteTestModalLayout = ({ test, onDelete }) => {
	const dispatch = useDispatch();

	const handleDelete = () => {
		onDelete && onDelete();
		dispatch(closeModal());
	};

	return (
		<div className="test-delete-confirm-modal">
			<h3>Czy jesteś pewien?</h3>
			<div>
				<span>Potwierdź usunięcie testu</span>
				<span>{test.nazwa}</span>
			</div>
			<div className="confirm-buttons">
				<Button color="transparent" onClick={() => dispatch(closeModal())}>
					anuluj
					<Icon name="times" width="14" height="14" color={colors.greyBlack} />
				</Button>
				<Button color="primary text-white" onClick={handleDelete}>
					usuń test
					<Icon name="trash" width="12" height="12" color={colors.white} />
				</Button>
			</div>
		</div>
	);
};

export default DeleteTestModalLayout;
